/**
 * Shutter speed field formatters
 * Handles special "1/250" format and fraction display
 */

/**
 * Formats shutter speed for display (e.g., "1/250s" or "2.5s")
 */
export const shutterSpeedDisplayFormatter = (value) => {
  if (value == null) return '-';
  const num = parseFloat(value);
  if (num < 1) return `1/${Math.round(1/num)}s`;
  return `${value}s`;
};

/**
 * Formats shutter speed for EXIF storage as fraction array
 */
export const shutterSpeedExifFormatter = (value) => {
  if (!value) return null;
  // Parse "1/250" or "2.5" format
  if (value.includes('/')) {
    const [num, den] = value.split('/').map(Number);
    return [num, den];
  }
  const num = parseFloat(value);
  return [Math.round(num * 1000), 1000];
};

/**
 * Formats shutter speed from EXIF fraction array
 */
export const shutterSpeedFromExifFormatter = (value) => {
  if (!value) return '';
  if (Array.isArray(value)) {
    const decimal = value[0] / value[1];
    if (decimal < 1) return `1/${Math.round(1/decimal)}`;
    return decimal.toString();
  }
  return value.toString();
};

/**
 * Returns standard shutter speed field formatters
 */
export function getShutterSpeedFormatters(options = {}) {
  const { defaultValue = '' } = options;
  return {
    formatForDisplay: shutterSpeedDisplayFormatter,
    formatForExif: shutterSpeedExifFormatter,
    formatFromExif: shutterSpeedFromExifFormatter,
    defaultValue
  };
}
